import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import style from "./style.module.scss";

/**
 * ResultsBase Component
 *
 * A React component to display results with associated images.
 * It fetches the images dynamically based on the result keys.
 */
class ResultsBase extends React.Component {
  /**
   * Render the image based on a given result key.
   *
   * @param {string} key - The key corresponding to a result type (e.g., "a+", "k-").
   * @returns {JSX.Element} - A div containing the corresponding image.
   */
  renderImage(key) {
    const imgSrc = this.props.images[key + this.props.results[key]];

    return (
      <div className={style.ImageBox}>
        <img alt="" className={style.Image} src={imgSrc} />
      </div>
    );
  }

  render() {
    return (
      <div className={style.Container}>
        {this.renderImage("a+")}
        {this.renderImage("a-")}
        {this.renderImage("k+")}
        {this.renderImage("k-")}
      </div>
    );
  }
}

// Define the expected prop types for this component.
ResultsBase.propTypes = {
  heading: PropTypes.string.isRequired, // The main heading for the results section.
  explaination: PropTypes.string.isRequired, // Text explaining the results.
  images: PropTypes.object.isRequired, // Object containing the paths to images.
  results: PropTypes.object, // The results data, fetched from the Redux store.
};

// Default values for the props.
ResultsBase.defaultProps = {
  results: {},
};

/**
 * Map the Redux state to the component's props.
 *
 * @param {Object} state - The current Redux state.
 * @returns {Object} - An object with the mapped state to props.
 */
const mapStateToProps = (state) => ({
  results: state.results,
});

// Connect the ResultsBase component to the Redux store and export it.
export const RestrictionDigestResults = connect(mapStateToProps)(ResultsBase);
